import axios from 'axios'

export const baseURL = process.env.REACT_APP_PROD
  ? '/'
  : `${window.location.protocol}//rbc-pik.9-lines.com`
export const baseURLImage = process.env.REACT_APP_PROD ? '' : baseURL

const axiosInstance = axios.create({
  baseURL,
})

axiosInstance.interceptors.request.use((request: any) => {
  request.headers = {
    ...request.headers,
  }
  return request
})

axiosInstance.interceptors.response.use(
  (response: any) => response,
  ({ response }: any) => {
    const { status } = response || {}
    if (status === 401 || status === 403) {
      // error page
      // console.log(404);
    }

    return Promise.reject(response)
  }
)

export default axiosInstance
